module.exports = __webpack_public_path__ + "static/media/MAPPING.85f6785a.png";